import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import './richTextEditor.css';

// Módulos y formatos a nivel de módulo: si se recrean en cada render, Quill
// se re-inicializa y pierde el foco/cursor.
const MODULES = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['blockquote', 'link'],
    ['clean'],
  ],
};

const FORMATS = [
  'header',
  'bold', 'italic', 'underline', 'strike',
  'list',
  'blockquote', 'link',
];

export function RichTextEditor({ value, onChange, placeholder }) {
  return (
    <div className="rte-wrap">
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={MODULES}
        formats={FORMATS}
        placeholder={placeholder}
      />
    </div>
  );
}
